module.exports = __webpack_public_path__ + "media/images/guideline/C02-66b2540a1c485f4f3e4e98d8ad20466f.jpg";